import type { ToastContent } from './useShowEditorToast';
import getReduxStore from '../../app/redux/getReduxStore';
import { UIActions } from '../../ui/uiSlice';

const showEditorToast = (content: ToastContent, duration?: number) => {
  const store = getReduxStore();
  store.dispatch(UIActions.pushToast(content, duration));
};

export default showEditorToast;
